/* eslint-disable @typescript-eslint/naming-convention */
// eslint-disable-next-line no-shadow
export enum MediaQuery {
  XSmall = '(max-width: 479px)',
  Small = '(min-width: 480px)',
  Medium = '(min-width: 768px)',
  Large = '(min-width: 1024px)',
  XLarge = '(min-width: 1440px)',
  XXLarge = '(min-width: 1640px)',
  XXXLarge = '(min-width: 1920px)',
}
